<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Классное руководство</h2>
          <v-spacer></v-spacer>
          <v-text-field
            class="mx-5"
            outlined clearable hide-details dense flat label="фильтр" v-model="search" style="max-width: 300px"
          ></v-text-field>
          <v-dialog
            v-model="dialogNewClasshead"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mr-4" color="primary" v-on="on">Новый классный руководитель</v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Новый классный руководитель
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogNewClassheadClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>

                <v-autocomplete
                v-model="ipersonid"
                :items="employees"
                item-value="personid"
                item-text="fullname"
                label="Учитель"
                ></v-autocomplete>

                <v-autocomplete
                v-model="ipositionid"
                :items="classes"
                item-value="positionid"
                item-text="name"
                label="Класс"
                ></v-autocomplete>

              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="inaction || !ipersonid || !ipositionid"
                  @click="addClasshead()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogNewClassheadClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :headers="headers"
          :items="classheads"
          :search="search"
          :items-per-page="-1"
          item-key="name"
          hide-default-footer
          dense
          :sort-by="sortby"
        >
          <template v-slot:item.registered="{ item }">
            <span v-if="item.registered === true" style="color:green">ЕСТЬ</span>
            <span v-else style="color:red">НЕТ</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn color="error" x-small text @click="deleteItem(item)">
              удалить
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.cts="{ item }">
            {{ dateFormat(item.cts) }}
          </template>
          <template v-slot:item.arestudents="{ item }">
            <span v-if="item.arestudents === true">УЧЕНИКИ</span>
            <span v-else>СОТРУДНИКИ</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Classheads',
  data: () => ({
    inaction: false,
    dialogNewClasshead: false,
    classheads: [],
    classes: [],
    employees: [],
    search: '',
    headers: [
      { text: 'класс', value: 'positionname', width: '150' },
      { text: 'учитель', value: 'fullname', width: '300' },
      { text: 'Регистрация в ЛК', value: 'registered', width: '200' },
      { text: 'дата добавления', value: 'cts', width: '150', filter: (value, search, item) => true },
      { text: 'действия', value: 'action', sortable: false },
    ],
    ipersonid: null,
    ipositionid: null,
    sortby: 'positionname',
  }),
  methods: {
    async fetch () {
      try {
        await Promise.all([
          this.fetchClassheads(),
          this.fetchClasses(),
          this.fetchEmployees()
        ])
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchClassheads () {
      const { classheads, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-classheads'
      })
      this.classheads = classheads
    },
    async fetchClasses () {
      const { classes, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-classes'
      })
      this.classes = classes
    },
    async fetchEmployees () {
      const { employees, meta } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-employees'
      })
      this.employees = employees
    },
    dialogNewClassheadClose () {
      this.dialogNewClasshead = false
      this.ipositionid = null
      this.ipersonid = null
    },
    async addClasshead () {
      try {
        if (this.inaction) return
        this.inaction = true
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-classhead',
          pl: {
            personid: this.ipersonid,
            positionid: this.ipositionid,
          }
        })
        this.$store.dispatch('snack', meta)
        this.dialogNewClassheadClose()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inaction = false
        this.fetchClassheads()
      }
    },
    async deleteItem (item) {
      try {
        await this.$store.dispatch('confirm', `Удалить классное руководство ${item.fullname} @ ${item.positionname} ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-classhead',
          pl: item
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetchClassheads()
      }
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
